/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PersonalAssetSpecialTypeEnum {
    Monery = 'monery',
    Investown = 'investown'
}

export function PersonalAssetSpecialTypeEnumFromJSON(json: any): PersonalAssetSpecialTypeEnum {
    return PersonalAssetSpecialTypeEnumFromJSONTyped(json, false);
}

export function PersonalAssetSpecialTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetSpecialTypeEnum {
    return json as PersonalAssetSpecialTypeEnum;
}

export function PersonalAssetSpecialTypeEnumToJSON(value?: PersonalAssetSpecialTypeEnum | null): any {
    return value as any;
}

